import { request } from './api';
export const siteIdentity = {
    session: () => request('/api/auth/session'),
    login: (username, password) => request('/api/auth/login', 'POST', { username, password }),
    logout: () => request('/api/auth/logout', 'POST'),
};
